import { Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

export const Unpause = () => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Text size="sm" fw={500}>
        {t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.UNPAUSE_DEBTOR)}
      </Text>
      <Text size="sm" c="dimmed">
        {t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.UNPAUSE_DEBTOR_HINT)}
      </Text>
    </Stack>
  );
};
